/**
 * ViewPastDiscountCampaignCtrl controller
 * Add/edit partner Product
 */

// controller mixins
ViewPastDiscountCampaignCtrl.mixes = [
  ['m2mCtrlMixin', 'dc', 'subscriptions']
]

/**
 * ViewPastDiscountCampaignCtrl controller
 *
 * @class ViewPastDiscountCampaignCtrl
 * @memberof mwApp/discountCampaign
 * @see mwApp/discountCampaign
 * @mixes mwApp/common.mixin:m2mCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/discountCampaign.controller:ViewPastDiscountCampaignCtrl
 */
/* @ngInject */
export default function ViewPastDiscountCampaignCtrl ($scope, $location, $uibModal, $http, alertLiteSvc, authSvc, DiscountCampaign, NetworkCurrency, dc, pckg) {
  var vm = this
  vm.viewMode = true

  vm.dc = dc
  vm.isNew = dc._isNew()

  NetworkCurrency.loadAll({ network: pckg }).then(res => {
    const currencies = res.filter(cur => cur.enabled)
    vm.defaultCurrency = currencies.length ? currencies[0].name : ''
  })

  vm.discount_campaign_statuses = {
    UPCOMING: 'Upcoming',
    EXPIRED: 'Expired',
    ACTIVE: 'Active'
  }

  /**
   * Redirect to previous page
   *
   * @memberof mwApp/discountCampaign.controller:ViewPastDiscountCampaignCtrl
   */
  vm.back = function () {
    $location.url(pckg._publicUrl + '/past-discounts')
  }

  $scope.$watch('vm.dc.subscriptions.length', () => {
    if (vm.dc.subscriptions.length) {
      let subscriptionsCurrencies = vm.dc.subscriptions.map(s => s.currency)
      subscriptionsCurrencies = Array.from(new Set(subscriptionsCurrencies)).filter(currency => currency)
      vm.mappedCurrency = subscriptionsCurrencies.join('/')
    } else {
      vm.mappedCurrency = null
    }
  })
}
